import React from 'react';
import MatGapCoreTransactionList from './MatGapCoreTransactionList';

export default function MatGapTransferList() {
  return (
    <MatGapCoreTransactionList
      title="GAP Material - Transfer Transactions"
      opTypes={["transfer"]}
    />
  );
}
